import buildPath from '@/tsClient/utilities/buildPath';
import integrationsClient, { ApiDefinition } from '@/tsClient/servers/integrationsService';

type THIS_API = ApiDefinition['/{provider}/creators/{creatorId}/mfa-code']['GET'];
type Input = THIS_API['params'];
type Output = THIS_API['response'];

const getMFAForIntegrationAccount = async ({ creatorId, provider }: Input): Promise<Output> => {
  const path = buildPath<THIS_API>('/{provider}/creators/{creatorId}/mfa-code', { creatorId, provider });
  const response = await integrationsClient.get(path);
  return response.data;
};

export default getMFAForIntegrationAccount;
